import React, { useEffect, useState } from "react";
import NormalTable from "../../../components/common/Tables/NormalTable";
import { getAllVenueBySlug, getReport } from "../../../api";
import { PulseLoader } from 'react-spinners';
import ExportToExcel from "../../../components/ExportToExcel/ExportToExcel";
import { useNightMode } from "../../../contexts/NightModeContext";
import FlatPickr from "react-flatpickr";
import FormattedDate from "../../../components/common/DateFormat/FormattedDate";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row
} from "reactstrap";
import { handleError } from "../../../utils/errorHandler";
import moment from "moment";
import CommonSelect from "../../../components/common/Select/CommonSelect";
import { isMobile } from "../../../utils/utils";
import flatpickr from "flatpickr";
const UserBookingStatusReport = () => {
  const { isNightMode } = useNightMode();
  const [bookingStatus, setBookingStatus] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [book, setBookNo] = useState("");
  const [fullBookingList, setFullBookingList] = useState<any[]>([]);
  const [fromDate, setFromDate] = useState<Date>();
  const [toDate, setToDate] = useState<Date>();
  const [reports, setReports] = useState([
    { title: "Successfull booking", iconClass: "fa-solid fa-circle-check fa-2x bg-dark", description: 0 },
    { title: "Total Attended", iconClass: "fa-solid fa-circle-check fa-2x bg-dark", description: 0 },
    { title: "Pending booking", iconClass: "fa-solid fa-spinner fa-2x bg-dark", description: 0 },
    { title: "Failed booking", iconClass: "fa-solid fa-circle-exclamation fa-2x bg-dark", description: 0 },
    { title: "Cancelled booking", iconClass: "fa-solid fa-circle-xmark fa-2x bg-dark", description: 0 },
    { title: "Total booking", iconClass: "fa-solid fa-square-check fa-2x bg-dark", description: 0 },
  ]);

  const [bookingList, setBookingList] = useState<any[]>([]);
  const [eventList, setEventList] = useState<any[]>([]);
  const [selectedVenue, setSelectedVenue] = useState<string>("");
  const [eventVenues, setEventVenues] = useState<any[]>([]);
  const [mobileTableData, setMobileTableData] = useState<any[]>([]);
  const mobileTableColumns = [
   
    { label: "Successfull booking", key: "confirmed",width: 180 },
    { label: "Total Attended", key: "attended",width: 180 },
    { label: "Pending booking", key: "pending",width: 180 },
    { label: "Failed booking", key: "failed",width: 180 },
    { label: "Cancelled booking", key: "cancelled",width: 180 },
    { label: "Total booking", key: "total" },
  ];
  interface Booking {
    bookingStatus: string;
    bookedBy: string;
    totalTicketAmount: number;
    currency?: string;
    totalTicketCount: number;
  }
  interface ReportItem {
    title: string;
    iconClass: string;
    description: string | number;
  }

  useEffect(() => {
    fetchDataAll();
    getEventVenue();
  }, []);

  const getEventVenue = async () => {
    try {
      const eventData = localStorage.getItem("eventData");
      if (!eventData) return;
      const eventSlug = JSON.parse(eventData).slugId;
      const resp = await getAllVenueBySlug(eventSlug);
      const venueOptions = resp.map((item: any) => {
        return {
          value: item.venueId,
          label: item.venueName
        }
      })
      const allVenue = {
        value: "0",
        label: "All Venues"
      }
      setEventVenues([allVenue, ...venueOptions])
    } catch (error) {
      handleError(error)
    }
  }
  const fetchDataAll = async () => {
    try {
      setIsLoading(true);

      const eventData = localStorage.getItem("eventData");
      console.log("eventData", eventData);
      if (eventData) {
        const eventSlug = JSON.parse(eventData).eventId;
        const venueId = localStorage.getItem("venueId");
        const response = await getReport(eventSlug);
        const activeBooking = response.filter((item: any) => item.bookedBy === "0" && item.venueId === venueId);
       
        if (activeBooking) {
          setBookingStatus(activeBooking);
          setFullBookingList(activeBooking);
        }
        let confirmed = 0;
        let cancelled = 0;
        let pending = 0;
        let failed = 0;
        let attended = 0;
        activeBooking.forEach((booking: Booking) => {

          if (booking.bookingStatus === "confirmed") confirmed++;
          else if (booking.bookingStatus === "cancelled") cancelled++;
          else if (booking.bookingStatus === "pending") pending++;
          else if (booking.bookingStatus === "failed") failed++;
          else if (booking.bookingStatus === "confirmed") {
            attended = Number(attended) + Number(booking.totalTicketCount);
          };
        });
        const total = activeBooking.length;
        setReports([
          { title: "Confirmed Booking", iconClass: "fa-solid fa-circle-check fa-2x bg-dark", description: confirmed },
          { title: "Pending Booking", iconClass: "fa-solid fa-spinner fa-2x bg-dark", description: pending },
          { title: "Cancelled Booking", iconClass: "fa-solid fa-circle-xmark fa-2x bg-dark", description: cancelled },
          { title: "Failed Booking", iconClass: "fa-solid fa-circle-exclamation fa-2x bg-dark", description: failed },
          { title: "Total Booking", iconClass: "fa-solid fa-square-check fa-2x bg-dark", description: total },
          { title: "Total Attended", iconClass: "fa-solid fa-circle-check fa-2x bg-dark", description: attended },
        ]);
        setMobileTableData([
          { id: 1, confirmed: confirmed, pending: pending, cancelled: cancelled, failed: failed, total: total, attended: attended },
        ]);

      }
    } catch (error) {
      console.error("Error fetching attendee report:", error);
    } finally {
      setIsLoading(false);
    }

  };
  const columns = [
    { label: "Booked No", key: "bookingNo" },
    {
      label: "Booked By", key: "Contact",
      cellContent: (row: any) => {
        return (
          <div>
            <span>{row?.Contact?.firstName}</span><br />
            <span>{row?.Contact?.email}</span><br />
            <span>{row?.Contact?.phoneNo}</span>
          </div>
        )
      }
    },

    { label: "Status", key: "bookingStatus" },
    { label: "Ticket Count", key: "totalTicketCount" },
    {
      label: "Ticket Amount", key: "TicketType",
      cellContent: (row: any) => <span>{row?.TicketType?.price}</span>,

    },
    { label: "Discount Amount", key: "discountAmount " },
    { label: "Booked Date", key: "createdAt", cellContent: (row: any) => <FormattedDate dateString={row.createdAt} /> },


  ];
  useEffect(() => {
  const filtered = fullBookingList.filter((attendee: any) => {
    const bookno = attendee?.bookingNo?.toLowerCase() || "";
    const name = attendee?.Contact?.firstName?.toLowerCase() || "";
    const bookingDate = moment(attendee?.createdAt);
    const isInDateRange =
      (!fromDate || bookingDate.isSameOrAfter(moment(fromDate).startOf("day"))) &&
      (!toDate || bookingDate.isSameOrBefore(moment(toDate).startOf("day")));
    return (
      bookno.startsWith(book.toLowerCase()) &&
      name.startsWith(search.toLowerCase()) &&
      isInDateRange
    );
  });

  setBookingStatus(filtered);
}, [book, search, fromDate, toDate, fullBookingList]);


  const onSelectedVenue = async (e: any) => {
    setIsLoading(true);
    try {
      const selectedVenue = e;
      const eventData = localStorage.getItem("eventData");
      if (!eventData) return;
      const eventSlug = JSON.parse(eventData).eventId;
      const response = await getReport(eventSlug);
      if (selectedVenue !== "0") {
        const activeBooking = response.filter((item: any) => item.bookedBy === "0" && item.venueId === selectedVenue);
        setBookingStatus(activeBooking);
        setFullBookingList(activeBooking);
        let confirmed = 0;
        let cancelled = 0;
        let pending = 0;
        let failed = 0;
        let attended = 0;

        activeBooking.forEach((booking: Booking) => {
          if (booking.bookingStatus === "confirmed") confirmed++;
          else if (booking.bookingStatus === "cancelled") cancelled++;
          else if (booking.bookingStatus === "pending") pending++;
          else if (booking.bookingStatus === "failed") failed++;
          else if (booking.bookingStatus === "confirmed") {
            attended = Number(attended) + Number(booking.totalTicketCount);
          };
        });
        const total = activeBooking.length;
        setReports([
          { title: "Confirmed Booking", iconClass: "fa-solid fa-circle-check fa-2x bg-dark", description: confirmed },
          { title: "Pending Booking", iconClass: "fa-solid fa-spinner fa-2x bg-dark", description: pending },
          { title: "Cancelled Booking", iconClass: "fa-solid fa-circle-xmark fa-2x bg-dark", description: cancelled },
          { title: "Failed Booking", iconClass: "fa-solid fa-circle-exclamation fa-2x bg-dark", description: failed },
          { title: "Total Booking", iconClass: "fa-solid fa-square-check fa-2x bg-dark", description: total },
          { title: "Total Attended", iconClass: "fa-solid fa-circle-check fa-2x bg-dark", description: attended },
        ]);
        setMobileTableData([
          { id: 1, confirmed: confirmed, pending: pending, cancelled: cancelled, failed: failed, total: total, attended: attended },
        ]);
      } else {
        fetchDataAll();
      }
      setSelectedVenue(selectedVenue);
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  }
  return (
    <div className="dashboard-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="d-main-title">
              <h3>
                <i className="mx-2">
                  <i className="fa-solid fa-chart-simple "></i>
                </i>
                Booking Status Report
              </h3>
            </div>
          </div>
          <div className="col-md-12">
            <div className="main-card mt-1">
              <div className="dashboard-wrap-content p-2">
                <div className="d-md-flex flex-wrap align-items-center">
                  <div className="dashboard-date-wrap mt-4">
                    <div className="form-group">
                      {isMobile() && (
                        <div className="search-container position-relative d-flex flex-column flex-md-row align-items-center gap-3 p-2">
                          {/* <div className="search-group position-relative w-100 mb-2 mb-md-0">
                            <CommonSelect
                              options={eventVenues}
                              value={selectedVenue}
                              onChange={(e) => onSelectedVenue(e.target.value)}
                              label="Event Venue"
                            />
                            <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                          </div> */}
                          <div className="search-group position-relative e-w-full mb-2 mb-md-0">
                            <input
                              className="form-control h_50 ps-4 e-w-full"
                              type="text"
                              placeholder="Search by Booked No"
                              value={book}
                              onChange={(e) => setBookNo(e.target.value)}

                            />
                            <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                          </div>
                          <div className="search-group position-relative e-w-full mb-2 mb-md-0">
                            <input
                              className="form-control h_50 ps-4 e-w-full"
                              type="text"
                              placeholder="Search by Booked By"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                            />
                            <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>

                          </div>
                          <div className=" search-group position-relative e-w-full mb-2 mb-md-0">
                          <label>From Date:</label>
                         <FlatPickr
                          className="form-control"
                          value={fromDate}
                          onChange={([date]) => setFromDate(date)} 
                          options={{
                            dateFormat: "Y-m-d"
                          }}
                          placeholder="Select a date"
                        />
                        </div>
                        <div className="search-group position-relative e-w-full mb-2 mb-md-0">
                          <label>To Date:</label>
                          <FlatPickr
                            className="form-control"
                            value={toDate}
                            onChange={([date]) => setToDate(date)} 
                            options={{
                              dateFormat: "Y-m-d"
                            }}
                            placeholder="Select a date"
                          />
                        </div>
                      
                          {/* <div className="search-group position-relative w-50 mb-2 mb-md-0">
                          <ExportToExcel
                            data={bookingStatus}
                            fileName="BookingStatus_Report"
                          />
                        </div> */}

                        </div>
                      )}
                      <Container fluid>
                        <Row className="mb-3">
                          <Col xl="15" className="mb-2">
                            <Row>
                              {isMobile() && (
                                <NormalTable columns={mobileTableColumns} data={mobileTableData} getRowId={(row: any) => row.id} />
                              )}
                              {!isMobile() && (reports || [])?.map((report, key) => (
                                <Col md="4" sm="2" lg="3" key={"col" + key} className="col-md-4 col-sm-2 col-lg-3">
                                  <Card className={`mini-stats-wid ${isNightMode ? 'bg-dark text-white' : 'bg-light text-black'} mb-1`}>
                                    <CardBody>
                                      <div className="d-flex">
                                        <div className="flex-grow-1">
                                          <p className="fw-medium ">
                                            {report.title}
                                          </p>
                                          <h4 className="mb-0">
                                            {report.description}
                                          </h4>
                                        </div>
                                        <div className="avatar-sm rounded-circle  align-self-center mini-stat-icon">
                                          <span className="avatar-title rounded-circle ">
                                            <i
                                              className={
                                                "bx " +
                                                report.iconClass +
                                                " font-size-24"
                                              }
                                            ></i>
                                          </span>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Card>
                                </Col>
                              ))}
                            </Row>
                          </Col>
                        </Row>
                      </Container>
                      {!isMobile() && (
                        <div className="search-container position-relative d-flex flex-column flex-md-row align-items-center gap-3 p-2">
                          {/* <div className="search-group position-relative w-100 mb-2 mb-md-0">
                            
                            <CommonSelect
                              options={eventVenues}
                              value={selectedVenue}
                              onChange={(e) => onSelectedVenue(e.target.value)}
                              label="Event Venue"
                            />
                            <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                          </div> */}
                          <div className="search-group position-relative w-50 mb-2 mb-md-0">
                            <input
                              className="form-control h_40 ps-4"
                              type="text"
                              placeholder="Search by Booked No"
                              value={book}
                              onChange={(e) => setBookNo(e.target.value)}
                            />
                            <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                          </div>
                          <div className="search-group position-relative w-50 mb-2 mb-md-0">
                            <input
                              className="form-control h_40 ps-4"
                              type="text"
                              placeholder="Search by Booked By"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                            />
                            <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>

                          </div>
                          <div className=" search-group position-relative e-w-full mb-2 mb-md-0">
                          <div className=" search-group position-relative e-w-full mb-2 mb-md-0">
                          <label>From Date:</label>
                          <FlatPickr
                            className="form-control"
                            value={fromDate}
                            onChange={([date]) => setFromDate(date)} 
                            options={{
                              dateFormat: "Y-m-d"
                            }}
                            placeholder="Select a date"
                          />
                        </div>
                        <div className="search-group position-relative e-w-full mb-2 mb-md-0">
                          <label>To Date:</label>
                          <FlatPickr
                            className="form-control"
                            value={toDate}
                            onChange={([date]) => setToDate(date)} 
                            options={{
                              dateFormat: "Y-m-d"
                            }}
                            placeholder="Select a date"
                          />
                        </div>
                        </div>
                      
                          {/* <div className="search-group position-relative w-50 mb-2 mb-md-0">
                          <ExportToExcel
                            data={bookingStatus}
                            fileName="BookingStatus_Report"
                          />
                        </div> */}

                        </div>
                      )}

                      <div className="relative-input position-relative"></div>
                    </div>
                  </div>
                  <div className="rs ms-auto mt-4 mt_r4"></div>
                </div>
              </div>
            </div>
            {isLoading ? (
              <div className="d-flex justify-content-center py-4">
                <PulseLoader
                  color="#ffffff"
                  size={9}
                  speedMultiplier={1}
                />
              </div>
            ) : (
              <div className="event-list">
                <div className="tab-content">
                  <div
                    className="tab-pane fade show active"
                    id="orders-tab"
                    role="tabpanel"
                  >
                    <NormalTable columns={columns} data={bookingStatus} getRowId={(row: any) => row.bookingId} />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserBookingStatusReport;
